import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-x4 xl:mb-x6" }
const _hoisted_2 = { class: "mb-x2 sm:mb-x5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "w-200 mb-x1" }
const _hoisted_5 = { class: "w-2/3" }

import SkeletonLine from '@/shared/spinners/SkeletonLine.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFacetMaterialsSkeleton',
  setup(__props) {

const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SkeletonLine, { class: "h-40" })
    ]),
    (_unref(labels).overlayAllMaterialsContentDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SkeletonLine)
          ]),
          _createElementVNode("div", null, [
            _createVNode(SkeletonLine, { class: "mb-5" }),
            _createVNode(SkeletonLine, { class: "mb-5" }),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(SkeletonLine)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})